export default __webpack_public_path__ + "static/media/box.d316c6b9.png";